/********************************************************************************
Filename: np-layout-grid.js
Created: 09 Oct 2020
Author: Ron Robertson
Description: Displays a grid used for creating layouts that match a mockup
Attributes:
    color: [CSS color values] The color of the grid
    opacity: [Decimal from 0-1] The opacity of the grid
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>

            .layoutGridTrigger {
                position: fixed;
                top: 2px;
                right: 2px;
                z-index:50;
                color: red;
            }
            .layoutGridWrapper {
                position:relative;
                width:var(--content-width);
                margin:0 auto;
            }
            .layoutGrid {
                position: absolute;
                left:0px;
                right:0px;
                z-index: 900;
                margin-top: -50000px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            .layoutGrid.off {
                display: none;
            }

            .layoutGrid div {
                height: 50000px;
                background-color:rgba(255,0,0,0.1);
                width: 27.5px;

            }

            /* Six col layout - hide half */
            .layoutGrid div:nth-child(odd) {
                display:none;
            }

            /* small-up */
            @media (min-width: 480px) {
                .layoutGrid div {
                    width: 54.16667px
                }
            }
            /* medium-up */
            @media (min-width: 768px) {
                .layoutGrid div {
                    width: 41.5px;
                }

                /* 12 col layout - show all */
                .layoutGrid div:nth-child(odd) {
                    display: block;
                }
            }
            /* large-up */
            @media (min-width: 960px) {
                .layoutGrid div {
                    width: 57.5px;
                }
            }
            /* xlarge-up */
            @media (min-width: 1200px) {
                .layoutGrid div {
                    width: 77.5px;
                }
            }
            /* hd-up */
            @media (min-width: 1920px) {
                .layoutGrid div {
                    width: 141.5px;
                }
            }

        </style>
      <a class="layoutGridTrigger" href="" >Toggle Grid</a>
        <div class="layoutGridWrapper">
            <div id="layoutGrid" class="layoutGrid off">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    `;

    class NpLayoutGrid extends HTMLElement {
      constructor() {
        /* Always call super first in constructor */
        super();

        /* bind 'this' to class in the method */
        this.toggle = this.toggle.bind(this);

        /* Use the Shadow DOM */
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));

        /* Reference to DOM Elements */
        this.layoutGrid = this.shadowRoot.getElementById("layoutGrid");
        this.toggleBtn = this.shadowRoot.querySelector(".layoutGridTrigger");
        this.gridDivs = this.shadowRoot.querySelectorAll(".layoutGrid div");

      } /* END constructor */

      /* Called when added to DOM */
      connectedCallback() {

        /* Set default attribute value */
        if (!this.hasAttribute('color')) {
          this.setAttribute('color', "red");
        }
        if (!this.hasAttribute('opacity')) {
            this.setAttribute('opacity', "0.1");
        }

        /* Set Event Listeners */
        this.toggleBtn.addEventListener('click', this.toggle);

      }

      /* Listen for when attributes change */
      /* attributes must be lowercase */
      static get observedAttributes() {
        return ['color', 'opacity'];
      }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

       if(name === 'color') {
           for(var i = 0; i < this.gridDivs.length; i++) {
            this.gridDivs[i].style.backgroundColor = this.color;
           }
       }
       if(name === 'opacity') {
        for(var i = 0; i < this.gridDivs.length; i++) {
         this.gridDivs[i].style.opacity = this.opacity;
        }
    }
      }

      /* Getting attributes */
      get color() {
        return this.getAttribute('color');
      }
      get opacity() {
        return this.getAttribute('opacity');
      }

      /* Settinng attributes */
      set color(newValue) {
        this.setAttribute('color', newValue);
      }
      set opacity(newValue) {
        this.setAttribute('opacity', newValue);
      }

      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        this.toggleBtn.removeEventListener('click', this.toggle);
      }

        /* Toggles the grid On/Off */
        toggle(e) {
            e.preventDefault();
            if(this.layoutGrid.classList.contains("off")) {
                this.layoutGrid.classList.remove("off");
            }else {
                this.layoutGrid.classList.add("off");
            }
        }

    } /* END class */

    window.customElements.define('np-layout-grid', NpLayoutGrid);

  })();
